import * as React from 'react'
import { InputNumber, Typography } from 'antd'
import { flow } from 'fp-ts/lib/function'
import { InputNumberProps } from 'antd/lib/input-number'
import { useOrganization } from '@library/react-toolkit'
import { useUnitInfo } from '../redux'

type Props = Omit<
  InputNumberProps,
  'value' | 'defaultValue' | 'onChange' | 'parser' | 'formatter'
> & {
  defaultValue?: number
  value?: number
  onChange?: (_: number | undefined) => void
  unit?: string
}

const convert = (divider: number) => (v: number | string | undefined) => {
  if (v === undefined) {
    return v
  }

  if (typeof v === 'string') {
    const val = parseFloat(v)
    return isNaN(val) ? undefined : val * divider
  }

  return v * divider
}
const numberExpression = /([0-9]+([,\.][0-9]*)?)/

const parse = (n: string | undefined) => {
  if (!n) {
    return ''
  }
  const match = numberExpression.exec(n)
  if (!match || match.length === 0) {
    return ''
  }
  return match[0]
}

const AmountInput = ({ onChange, defaultValue, value, ...rest }: Props) => {
  const organization = useOrganization()
  const unitInfo = useUnitInfo(rest.unit ?? organization?.asset ?? '')

  return (
    <InputNumber
      {...rest}
      defaultValue={
        defaultValue === undefined
          ? defaultValue
          : defaultValue / unitInfo.divider
      }
      formatter={n => `${n || '0'}`}
      parser={parse}
      value={value === undefined ? value : value / unitInfo.divider}
      addonAfter={<Typography.Text> {unitInfo.symbol} </Typography.Text>}
      onChange={
        !!onChange ? flow(convert(unitInfo.divider), onChange) : undefined
      }
    />
  )
}

export default AmountInput
